import { useEffect, useImperativeHandle, useRef } from "react";
import { TextController } from "../../components/TextController";

export const DropdownGame = (props) => {
    const { gameState, setGameState, animated, onCompleted, ref } = props;

    const textControllerRef = useRef(null);

    useImperativeHandle(ref, () => ({
        entryAnimation: async () => {
            textControllerRef.current.entryAnimation({ delay: .3 });
        },
        checkAnimation: async (userAnswer) => {
            if (!userAnswer) return;
            const wordIds = Object.keys(userAnswer);
            
            for (let i = 0; i < wordIds.length; i++) {
                const id = wordIds[i];
                const status = userAnswer[id];

                const word = textControllerRef.current?.getWordRef(id); 
                if(!word) continue;

                if (status === 'correct') {
                    await word.success();
                } else if (status === 'wrong') {
                    await word.fail();
                } else {
                    await word.empty();
                }
            }
        }
    }));

    useEffect(() => {
        if (gameState.idBlanks.every(blank =>  blank.fill !== null && blank.fill !== '')) {
            setTimeout(() => onCompleted?.(), 100);
        }
    }, [onCompleted, gameState.idBlanks]);

    return (
            <TextController
                ref={textControllerRef}
                // onChange={handleOnChange}
                gameState={gameState}
                setGameState={setGameState}
                animated={animated}
            />
        )
}